import $ from 'jquery';
import $hub from '../utility/events-hub';

import loadGoogleMapsApi from '../utility/load-google-api';
import config from '../components/map/config';
import map from '../components/map/index';
import geocoder from '../components/map/geocoder';

const opts = {
    widget: '[data-module="storelist"]',
    container: '[data-container]',
    content: '[data-content]',
    region: '[data-region]',
    storeList: '[data-store-list]',
    store: '[data-store]',
    form: '[data-form]',
    results: '[data-results]',
    empty: '[data-empty]',
    selected: '[data-selected]',
    selectedContent: '[data-selected-content]',
    selectedTail: '[data-selected-tail]',
    selectedTrigger: '[data-selected-trigger]',
    back: '[data-back]',
    nearest: '[data-nearest]'
};

const $widget = $(opts.widget);
const $container = $(opts.container);
const $content = $(opts.content);

const $storeList = $(opts.storeList);
const $regions = $(opts.region);
const $stores = $(opts.store);

const $form = $(opts.form);
const $formInput = $form.find('[name="q"]');

const $backBtn = $(opts.back);

const $selected = $(opts.selected);

let _queryCache;
let _containerHeight;
let _hasSelectedStore = false;
let _googleMaps;

const debounce = (func, wait, immediate) => {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

const loadGoogleMaps = (mapApiKey) => {
    loadGoogleMapsApi({key: mapApiKey}).then((api) => {
        _googleMaps = api;
        window.google = window.google || {};
        window.google.maps = api;
    });
};

const animateWrapHeight = (delayArg) => {
    const delay = delayArg || 0;
    const targetHeight = _hasSelectedStore ? $selected.height() : _containerHeight;

    $container.delay(delay).animate({'height': targetHeight}, 300, () => {
        if (_hasSelectedStore) {
            $content.css('position', 'absolute');
            $selected.css('position', 'relative');
        } else {
            $content.css('position', 'relative');
            $selected.css('position', 'absolute');
        }
        $container.css('height', 'auto');
    });
};

const clear = (clearInput = true) => {
    _hasSelectedStore = false;
    if (clearInput) $formInput.val('');
    $regions.removeClass('active-region').show();
    $stores.show();
    $widget
        .removeClass('loading')
        .removeClass('has-selected-store has-active-region')
        .removeClass('has-no-results has-no-results-multiple has-no-results-advanced');
    animateWrapHeight(400);
};

// temp lang fix - b2c store locator leftover
const hackForNoRegions = () => {
    $regions.each((i, el) => {
        const $el = $(el);
        const region = $el.data('region');

        if (!region) {
            $widget.addClass('tempfix-lang'); // add style for back button to quickfix
            $el.trigger('click'); // show empty region as default

            $backBtn.off('click'); // remove default clearing of region
            $backBtn.on('click', function (e) { // add new clearing of region that default to the no-name-region
                e.preventDefault();
                clear();
                $el.trigger('click');
            });
        }
    });
};

const selectStore = (id) => {
    const store = $('[data-store-info="{' + id + '}"]');
    const content = store.find(opts.selectedContent).html();
    const tail = store.find(opts.selectedTail).html();

    $selected.find(opts.selectedContent).html(content);
    $selected.find(opts.selectedTail).html(tail);
    $selected.find(opts.selectedTrigger).on('click', (event) => {
        $hub.publish($hub.event.storeSelected, { event });
    });

    _hasSelectedStore = true;
    $widget.addClass('has-selected-store');
    animateWrapHeight();
};

const selectRegion = (el) => {
    const $el = $(el);
    if ($el.hasClass('active-region')){
        return;
    }
    $el.addClass('active-region');
    $el.siblings().removeClass('active-region');
    $widget.addClass('has-active-region');
    $storeList.scrollTop(0);
};

const getMarkers = () => {
    const markersArray = [];
    $stores.each(function () {
        const $store = $(this);
        const markerObj = {
            position: {
                lat: parseFloat($store.data('lat')),
                lng: parseFloat($store.data('lng'))
            },
            storeId: $store.data('store'),
            filters: $store.data('filters')
        };
        const marker = new _googleMaps.Marker(markerObj);
        markersArray.push(marker);
    });
    return markersArray;
};

const searchByLocation = (lat, lng) => {
    const closestStores = map.findStoresNearest({lat: lat, lng: lng, markers: getMarkers()});
    const storeDOMs = [];

    closestStores.forEach((storeMarkerObj) => {
        $stores.each((i, el) => {
            if ($(el).data('store') === storeMarkerObj.storeMarker.storeId ) {
                storeDOMs.push($(el));
            }
        });
    });

    if (storeDOMs.length === 0) {
        $widget.addClass('has-no-results-advanced');
    } else {
        $(storeDOMs).each(function (i, storeDOM) {
            $(storeDOM).add($(storeDOM).parents('[data-region]')).show();
            $(storeDOM).parent().append($(storeDOM));
            $(storeDOM).show();
        });
    }

    $widget.removeClass('loading');
};

const searchNearest = (query) => {
    $widget
        .addClass('loading')
        .removeClass('has-no-results has-no-results-multiple has-no-results-advanced');

    geocoder.callGoogleApi(query, (success, data) => {
        if (success) {
            if (data.result.length === 1) {
                const match = data.result[0];
                if (match.address_components.length > 1) {
                    const location = match.geometry.location;
                    searchByLocation(location.lat(), location.lng());
                } else {
                    $widget.addClass('has-no-results-advanced');
                }
            } else {
                $widget.addClass('has-no-results-multiple');
            }
        } else {
            $widget.addClass('has-no-results-advanced');
        }
        $widget.removeClass('loading');
    });
};

const searchByString = (query) => {
    $widget
        .addClass('loading')
        .removeClass('has-no-results has-no-results-multiple has-no-results-advanced');

    let regionsCount = 0;
    const regionsList = [];
    $regions.each(function(i, region) {
        let storeCount = 0;
        const $region = $(region);

        $region.find('[data-store]').each(function() {
            const $store = $(this);
            const searchString = $store.data('search-string').toLowerCase();

            if (searchString.indexOf(query) !== -1) {
                storeCount++;
                $store.show();
            } else {
                $store.hide();
            }
        });

        if (storeCount > 0) {
            regionsList.push($region);
            regionsCount++;
            $region.show();
        } else {
            $region.hide();
        }
    });

    if (regionsCount === 0) {
        $widget.addClass('has-no-results');
    } else if (regionsCount === 1) {
        selectRegion(regionsList[0]);
    }
    $widget.removeClass('loading');
};

const search = () => {
    _containerHeight = $container.height();
    const val = $formInput.val().trim().toLowerCase();

    if (_queryCache === val) return false;
    _queryCache = val;

    if (val && val !== '' && val.length >= config.postalLength) {
        searchByString(val);
    } else {
        clear(false);
    }
};

const init = () => {
    if ($widget.length < 1 || !$widget.data('key')) return;

    loadGoogleMaps($widget.data('key'));

    // bind back button events
    $backBtn.on('click touchstart', (e) => {
        e.preventDefault();
        clear();
    });

    // bind region events
    $regions.on('click touchstart', function () {
        _containerHeight = $container.height();
        selectRegion(this);
    });

    // bind store events
    $stores.on('click touchstart', function (e) {
        e.stopPropagation();
        e.preventDefault();
        selectStore($(this).data('store'));
    });

    // bind form events
    $form.on('submit', (e) => {
        e.preventDefault();
        search();
    });

    $formInput.on('keyup', debounce(() => search(), 300));

    // bind search for nearest
    $(opts.nearest).on('click', function () {
        searchNearest(_queryCache);
    });

    // temp lang fix - b2c store locator leftover
    hackForNoRegions();
};

export default {
    init
};
